// extracted by mini-css-extract-plugin
module.exports = {"survey-etiology-chart":"style_survey-etiology-chart__3Tp8i"};